import React from "react";
import { IconEdit, IconCircleX } from "@tabler/icons-react";
import MOptionsMenu, { DropdownOption } from "@/components/ui/atoms/MOptionsMenu";

const OptionsMenuTest: React.FC = () => {
  const options: DropdownOption[] = [
    {
      id: "edit",
      label: "Edit",
      icon: <IconEdit />,
      onClick: () => alert("Edit clicked"),
    },
    {
      id: "delete",
      label: "Delete",
      icon: <IconCircleX  />,
      onClick: () => alert("Delete clicked"),
      delete: true
    },
    {
      id: "hidden",
      label: "Hidden",
      icon: <IconEdit />,
      onClick: () => alert("Hidden clicked"),
      isVisible: true,
    }
  ];

  return (
    <div style={{ padding: 40, minHeight: "100vh", background: "#f8f8f8", paddingLeft: 140 }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 32 }}>MOptionsMenu Demo</h1>
      <div style={{ position: "relative", display: "inline-block", paddingLeft: 240 }}>
        <MOptionsMenu options={options} />
      </div>
    </div>
  );
};

export default OptionsMenuTest;
